import React from 'react';
import { FormItemWrap, RemoteSelect } from 'react-structure-admin';
import {
  FilterRangePicker,
  FilterRemoteSelect,
  FilterRemoteSelectV2,
  FilterSelect,
  RemoteSelectTree,
  SelectPaymentMethod
} from 'components';
import moment from 'moment';
import isNullOrEmpty from 'util/functions/isNullOrEmpty';
import useCompany from 'core/hooks/useCompany';
import useCostCenter from 'core/hooks/useCostCenter';

const dateTypes = [
  { key: 'creationTime', label: 'Lançamento' },
  { key: 'dateOfCompensation', label: 'Regime de caixa' },
  { key: 'effectiveDate', label: 'Competência' },
  { key: 'dueDate', label: 'Vencimento' },
  { key: 'paymentDate', label: 'Baixa' }
];

const ranges = {
  Hoje: [moment(), moment()],
  Semana: [moment().startOf('week'), moment().endOf('week')],
  Mês: [moment().startOf('month'), moment().endOf('month')],
  Ano: [moment().startOf('year'), moment()]
};

const types = [
  { key: 'receipt', label: 'Receita' },
  { key: 'payment', label: 'Despesa' }
];

const invoiceStatus = [
  { key: 'created', label: 'Não emitida' },
  { key: 'authorized', label: 'Emitida' },
  { key: 'rejected', label: 'Rejeitada' },
  { key: 'canceled', label: 'Cancelada' }
];

const itemStatus = [
  { key: 'awaitingPayment', label: 'Em aberto' },
  { key: 'paid', label: 'Baixado' }
];

const FinancialEntryFilterAdvanced = ({ mode = 'all' }) => {
  const { enabledCostCenter } = useCostCenter();
  const { company, userCompany } = useCompany();

  const isEnableInvoice = () => {
    if (!isNullOrEmpty(userCompany, 'object')) {
      return userCompany.settings?.enableInvoice;
    }

    return company.settings?.enableInvoice;
  };

  return (
    <>
      <FilterSelect
        name="dateType"
        label="Filtrar por data"
        data={dateTypes}
        allowClear
      />
      <FilterRangePicker noStyle={false} name="rangePicker" ranges={ranges} />

      <FormItemWrap label="Categorias" name="categories">
        <RemoteSelectTree
          resource="categories"
          placeholder="Selecione"
          getSubItems={({ subCategories }) => subCategories}
          getTitle={({ name }) => name}
          params={{ types: mode === 'all' ? [] : [mode] }}
          allowClear
          normalizeItem={({ id, name, type }) => ({
            id,
            name,
            type
          })}
        />
      </FormItemWrap>

      <FilterRemoteSelect
        label="Contas"
        name="checkingAccounts"
        resource="checking-accounts"
        placeholder="Selecione"
        disabled={mode !== 'all'}
      />

      <FormItemWrap
        label="Centro de custo"
        name="costCenters"
        hidden={!enabledCostCenter}
      >
        <RemoteSelect resource="cost-centers" placeholder="Selecione" />
      </FormItemWrap>

      {isEnableInvoice() && (
        <FilterSelect
          name="invoiceStatus"
          label="Situação da nota"
          data={invoiceStatus}
          allowClear
        />
      )}

      <FormItemWrap label="Forma de baixa" name="paymentMethods">
        <SelectPaymentMethod mode="multiple" placeholder="Selecione" />
      </FormItemWrap>

      <FilterSelect
        name="itemStatus"
        label="Situação financeira"
        data={itemStatus}
        allowClear
      />

      <FilterRemoteSelect
        label="Profissionais"
        name="serviceProviderIds"
        resource="health-service-providers"
        params={{ onlyCurrentTenant: true }}
        placeholder="Selecione"
        mode="multiple"
      />
    </>
  );
};

export default FinancialEntryFilterAdvanced;
